import { ButtonGroup, DropdownButton, MenuItem } from 'react-bootstrap';
import { IPotentialDonor, IRecipient } from '@nkr/models/index';
import { ActionItems } from './action-items';

interface IProps {
    donor: IPotentialDonor,
    recipient: IRecipient,
    doesStudyExist: number,
    hasOutstandingOffer: boolean,
    isOpen: boolean,
    showMatchDecisionOptions: boolean,
    isNkrLogin: boolean,
    matchHistoryId: number,
    onActionToggle: (isOpen: boolean) => void,
    onActionItem: (eventKey: any) => void
}

const ActionsButton = (props: IProps) => {
    const handleActionItem = (eventKey: any) => {
        props.onActionItem(eventKey);
    }

    const renderMatchDecisionOptions = () => {
        if (props.showMatchDecisionOptions) {
            if (props.hasOutstandingOffer) {
                return <MenuItem href={`/center/${props.recipient.centerId}/recipient/evaluate-match/${props.matchHistoryId}`} target='_blank'><div style={{ backgroundColor: 'orange', padding: '3px 6px', borderRadius: 4, marginLeft: '-5px', marginRight: '-5px' }}>Pending Match Decision</div></MenuItem>;
            } else {
                return (
                    <>
                        <MenuItem eventKey={ActionItems.AcceptableFullyConfident} onSelect={handleActionItem}><span style={{ color: 'green' }}>Acceptable</span></MenuItem>
                        <MenuItem eventKey={ActionItems.NotAcceptable} onSelect={handleActionItem}><span style={{ color: 'red' }}>Not Acceptable</span></MenuItem>
                        <MenuItem eventKey={ActionItems.DeclineForAllRecipients} onSelect={handleActionItem}><span style={{ color: 'darkred' }}>Decline for ALL Recipients</span></MenuItem>
                        <MenuItem divider />
                    </>
                );
            }
        }

        return null;
    }

    return (
        <ButtonGroup className='pull-right'>
            <DropdownButton
                id='evaluate-donor-dropdown'
                title='Actions'
                bsStyle='primary'
                bsSize='lg'
                pullRight
                onToggle={props.onActionToggle}
                open={props.isOpen}
            >
                {renderMatchDecisionOptions()}

                {props.donor.rawTypingUploadPath != '' && (
                    <MenuItem eventKey={ActionItems.DonorHlaFile} onSelect={handleActionItem}>Donor HLA File</MenuItem>
                )}

                {props.donor.histogeneticsPdfTypingFile != '' && (
                    <MenuItem eventKey={ActionItems.Donor3GTypingReport} onSelect={handleActionItem}>Donor High Res Typing Report</MenuItem>
                )}

                {props.donor.histogeneticsPdfAboFile != '' && (
                    <MenuItem eventKey={ActionItems.DonorMolecularAboFile} onSelect={handleActionItem}>ABO+Subtype Confirmatory Typing Report</MenuItem>
                )}

                {props.doesStudyExist >= 1 && (
                    <MenuItem eventKey={ActionItems.ViewDonorCTStudy} onSelect={handleActionItem}>View Donor CT Study</MenuItem>
                )}

                {props.donor.ctReportUploadPath != '' && (
                    <MenuItem eventKey={ActionItems.DonorCTReport} onSelect={handleActionItem}>Donor CT Report</MenuItem>
                )}

                <MenuItem divider />
                <MenuItem eventKey={ActionItems.RequestInfo} onSelect={handleActionItem}>Request Info</MenuItem>

                {(props.isNkrLogin || props.recipient.cpra4 >= 99) && (
                    <MenuItem eventKey={ActionItems.RequestExmFreshBlood} onSelect={handleActionItem}>Request Exploratory XM (Fresh Blood)</MenuItem>
                )}
            </DropdownButton>
        </ButtonGroup>
    );
}

export default ActionsButton;